module.exports = __webpack_public_path__ + "img/gemingyingxiong-1@3x.fc79a377.png";